import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-settings-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M2 6.07365V9.92032C2 11.3336 2 11.3336 3.33333 12.2336L7 14.3536C7.55333 14.6736 8.45333 14.6736 9 14.3536L12.6667 12.2336C14 11.3336 14 11.3336 14 9.92698V6.07365C14 4.66698 14 4.66698 12.6667 3.76698L9 1.64698C8.45333 1.32698 7.55333 1.32698 7 1.64698L3.33333 3.76698C2 4.66698 2 4.66698 2 6.07365Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class SettingsIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 16 16');
}
